import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class TransferVehicleEntryCreate {
  vehicle_plate: string;
  license_qr: string;
  user_id: number;
  username: string;
  driver_name: string;
  driver_phone: string;
  driver_tc: string;
  region_point_id?: string;
  trust_card_number: string;
  departure_date: string;
  status: string;
  region_transfer_type_id: string | null;
  seal_numbers?: string[];
}

export class TransferVehicleEntryUpdate {
  vehicle_plate?: string;
  license_qr?: string;
  user_id?: number;
  username?: string;
  driver_name?: string;
  driver_phone?: string;
  driver_tc?: string;
  region_point_id?: number;
  trust_card_number?: string;
  departure_date?: string;
  arrival_date?: string;
  stopover_date?: string;
  status?: string;
  session_id?: number;
  region_transfer_type_id?: string;
  seal_numbers?: string[];
}

export class TransferVehicleEntryQueryDto extends IQueryPaginationDto {
  vehiclePlate?: string;
  userId?: number;
  driverTc?: string;
  status?: string;
  sessionId?: number;
  regionTransferTypeId?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
}

export class TransferVehicleEntry {
  id: string;
  vehiclePlate: string;
  licenseQr: string;
  userId: number;
  username: string;
  driverName: string;
  driverPhone: string;
  driverTc: string;
  trustCardNumber: string;
  departureDate: string; // ISO date string — gerekirse Date'e çevrilebilir
  status: string;
  sessionIds: number[];
  regionTransferTypeId: string;
  sealNumbers?: string[];
  createdAt: string;
  updatedAt: string;
}

export class TransferVehicleEntryResponse {
  @Type(() => TransferVehicleEntry)
  result: TransferVehicleEntry;
}

export class TransferVehicleEntryListResponse extends IPagination {
  @Type(() => TransferVehicleEntry)
  results: TransferVehicleEntry[];
}

export enum TransferVehicleEntryLogActionType {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  STATUS_CHANGE = 'status_change',
  ROUTE_SESSION_CREATE = 'route_session_create',
  ROUTE_SESSION_UPDATE = 'route_session_update',
  SMS_SENT = 'sms_sent',
  SMS_FAILED = 'sms_failed',
  VEHICLE_CREATE = 'vehicle_create',
  VEHICLE_FOUND = 'vehicle_found'
}

export class TransferVehicleEntryLog {
  id: string;
  transferVehicleEntryId: string;
  userId: number;
  username?: string;
  date: Date | string;
  actionType: TransferVehicleEntryLogActionType;
  message: string;
  previousState?: object;
  currentState?: object;
  metadata?: object;
  userAgent?: object;
  userIpAddressObject?: object;
  createdAt: Date | string;
  updatedAt: Date | string;
}

export class TransferVehicleEntryLogListResponse extends IPagination {
  @Type(() => TransferVehicleEntryLog)
  results: TransferVehicleEntryLog[];
  total: number;
}
